import React from "react";
import LeftPanel from "../../components/ToolbarLeftPanel/ToolbarLeftPanel";
import { useEditorMainPageContext } from "../contexts/EditorMainPageContext";

export const EditorLeftPanelSection = () => {
  const ctx = useEditorMainPageContext();

  return (
    <LeftPanel
      isOneTimeAsset={ctx.isOneTimeAsset}
      allMustUseDataEmpty={ctx.allMustUseDataEmpty}
      setBannerValidationCheck={ctx.setBannerValidationCheck}
      setState={ctx.setState}
      moduleStatuses={ctx.moduleStatuses}
      setModuleStatuses={ctx.setModuleStatuses}
      setRemoveSymbol={ctx.setRemoveSymbol}
      undoStack={ctx.undoStack}
      redoStack={ctx.redoStack}
      setUndoVersion={ctx.setUndoVersion}
      undoVersion={ctx.undoVersion}
      deleteModulesOnCanvas={ctx.deleteModulesOnCanvas}
      notUsedEditorToggle={ctx.notUsedEditorToggle}
      setNotUsedEditorToggle={ctx.setNotUsedEditorToggle}
      setEditModuleClicked={ctx.setEditModuleClicked}
      setDroppedTextIds={ctx.setDroppedTextIds}
      setDroppedComponentIds={ctx.setDroppedComponentIds}
      setClaimReferencesFoonotes={ctx.setClaimReferencesFoonotes}
      setDroppedComponentTextIds={ctx.setDroppedComponentTextIds}
      setScrollClaimReferencesFoonotes={ctx.setScrollClaimReferencesFoonotes}
      setClaimsArray={ctx.setClaimsArray}
      reusableTextIdsArray={ctx.reusableTextIdsArray}
      claimsArray={ctx.claimsArray}
      isReferenceFootnotes={ctx.isReferenceFootnotes}
      isReferenceFootnotesScrollbar={ctx.isReferenceFootnotesScrollbar}
      editComponent={ctx.editComponent}
      droppedTextIds={ctx.droppedTextIds}
      droppedTitleIds={ctx.droppedTitleIds}
      setDroppedTitleIds={ctx.setDroppedTitleIds}
      droppedComponentIds={ctx.droppedComponentIds}
      setModuleClaimsData={ctx.setModuleClaimsData}
      moduleClaimsData={ctx.moduleClaimsData}
      setDataGraphichImgDropped={ctx.setDataGraphichImgDropped}
      dataGraphichImgDropped={ctx.dataGraphichImgDropped}
      moduleSearchExpression={ctx.moduleSearchExpression}
      setModuleSearchExpression={ctx.setModuleSearchExpression}
      setSelectedModulecards={ctx.setSelectedModulecards}
      selectedModulecards={ctx.selectedModulecards}
      setModuleCardsDataLHS={ctx.setModuleCardsDataLHS}
      moduleCardsDataLHS={ctx.moduleCardsDataLHS}
      bannerId={ctx.bannerId}
      getEditSaveAssets={ctx.getEditSaveAssets}
      isModuleExist={ctx.isModuleExist}
      setIsModuleExist={ctx.setIsModuleExist}
      isNext={ctx.isNext}
      setIsNext={ctx.setIsNext}
      showModulesSection={ctx.showModulesSection}
      setShowModulesSection={ctx.setShowModulesSection}
      setOpenModulesModal={ctx.setOpenModulesModal}
      openModulesScreen={ctx.openModulesScreen}
      setOpenModulesScreen={ctx.setOpenModulesScreen}
      openModulesModal={ctx.openModulesModal}
      showBannertype={ctx.showBannertype}
      setModules={ctx.setModules}
      modules={ctx.modules}
      showAssettype={ctx.showAssettype}
      openTimeLine={ctx.openTimeLine}
      openTextWindow={ctx.openTextWindow}
      setOpenTextWindow={ctx.setOpenTextWindow}
      openModuleWindow={ctx.openModuleWindow}
      setOpenModuleWindow={ctx.setOpenModuleWindow}
      layerCompData={ctx.layerCompData}
      setLayerCompData={ctx.setLayerCompData}
      getLayerDetails={ctx.getLayerDetails}
      layerId={ctx.layerId}
      openShapesWindow={ctx.openShapesWindow}
      setOpenShapesWindow={ctx.setOpenShapesWindow}
      setOpenTimeLine={ctx.setOpenTimeLine}
      sendAtomDetails2Canvas={ctx.setAtom}
      setOpenImageWindow={ctx.setOpenImageWindow}
      openImageWindow={ctx.openImageWindow}
      selectedComponent={ctx.selectedComponent}
      setSelectedComponent={ctx.setSelectedComponent}
      imageOnCanvas={ctx.imageOnCanvas}
      playPause={ctx.playPause}
      linkedModulesType={ctx.linkedModulesType}
      setLinkedModulesType={ctx.setLinkedModulesType}
      loadingModules={ctx.loadingModules}
      setLoadingModules={ctx.setLoadingModules}
      setVeevaModuleCardData={ctx.setVeevaModuleCardData}
      veevaModuleCardData={ctx.veevaModuleCardData}
      toggleAnimatedBanner={ctx.toggleAnimatedBanner}
      playPauseRef={ctx.playPauseRef}
      toggleHideComp={ctx.toggleHideComp}
      toggleLockComp={ctx.toggleLockComp}
      setMultiSelectedComps={ctx.setMultiSelectedComps}
      handleCtrlClick={ctx.handleCtrlClick}
      isImageDropped={ctx.isImageDropped}
      setIsImageDropped={ctx.setIsImageDropped}
    />
  );
};
